import { ColumnDef, sortingFns } from '@tanstack/react-table';
import React from 'react';
import { CostCellContent } from './CostCellContent';
import { costSortValue, resolveCostDisplay } from './util';

interface LibraryCostFields {
  annualCostFormula: string | null;
  implementationCostFormula: string | null;
}

/**
 * Column def for a library-surface cost column (framework details / All Controls):
 * plain-number formula → amount, variable formula → "Formula" + calc icon, none → "–".
 * Column-picker only, not a default (product decision on CRPD-7209). `getId` maps a
 * row to its FrameworkControl id (compliance rows nest it).
 */
export const buildLibraryCostColumn = <T,>({
  id,
  header,
  field,
  costFields,
  getId,
}: {
  id: string;
  header: string;
  field: keyof LibraryCostFields;
  costFields: Map<string, LibraryCostFields>;
  getId: (row: T) => string;
}): ColumnDef<T> => ({
  id,
  header,
  accessorFn: (row) =>
    costSortValue(resolveCostDisplay({ value: null, formula: costFields.get(getId(row))?.[field], mode: 'library' })) ??
    undefined,
  cell: ({ row }) => (
    <CostCellContent
      display={resolveCostDisplay({
        value: null,
        formula: costFields.get(getId(row.original))?.[field],
        mode: 'library',
      })}
    />
  ),
  sortingFn: sortingFns.basic,
  sortUndefined: 'last',
});
